import React, { useEffect, useLayoutEffect, useState } from 'react';
import { my_orders, points_balance, shopping_cart } from '../../Image/Index';
import { Link, useNavigate } from 'react-router-dom';
import {
	clearCart,
	fetchVendorDetails,
	getCartDetails,
	getMerchantWallet,
} from '../../actions/auth';
import { decrypt, encrypt } from '../../utils/encodingdecoding';
import { useDispatch } from 'react-redux';

const Header = (props) => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const isMultiple =
		localStorage.getItem('isMultipleSelection') &&
		decrypt(localStorage.getItem('isMultipleSelection'));
	const [state, setState] = useState();
	const [name, setName] = useState();

	useEffect(() => {
		if (localStorage.getItem('name')) {
			let tempName = decrypt(localStorage.getItem('name'));
			tempName = `${tempName[0].toUpperCase()}${tempName.slice(1)}`;
			setName(tempName);
		}
	}, []);

	useEffect(() => {
		const fetchWallet = async () => {
			const token = JSON.parse(localStorage.getItem('token_gen'));
			const merchantCode = localStorage.getItem('merchantcode');
			getMerchantWallet(token?.access_token, decrypt(merchantCode)).then(
				(res) => {
					if (res.message === 'success') {
						res?.data?.wallets?.forEach((ele) => {
							if (ele.accounttype === 'Point') {
								setState(ele.balance);
								localStorage.setItem(
									'balance',
									encrypt(JSON.stringify(ele.balance)),
								);
							}
						});
					}
				},
			);
		};
		if (!localStorage.getItem('balance')) {
			fetchWallet();
		} else {
			setState(decrypt(localStorage.getItem('balance')));
		}
	}, []);

	// useLayoutEffect(() => {
	// 	const profile = JSON.parse(localStorage.getItem('profile'));
	// 	profile?.merchantcode &&
	// 		dispatch(getCartDetails({ customerCode: profile?.merchantcode }));
	// }, []);

	// useLayoutEffect(() => {
	// 	dispatch(fetchVendorDetails()).then((res) => {
	// 		res.errors === null &&
	// 			sessionStorage.setItem(
	// 				'venDetails',
	// 				encrypt(JSON.stringify(res.data)),
	// 			);
	// 	});
	// }, []);

	const handleCart = () => {
		navigate('/reseller-cart');
	};
	return (
		<div className='reseller_home__header'>
			<div className='reseller_home__header__left'>
				{props.name === 'Gift Cards' ? (
					<h3>{props.name}</h3>
				) : (
					<div className='back_header'>
						<Link to='/reseller-home'> {props.name}</Link>
					</div>
				)}
			</div>
			<div className='reseller_home__header__right'>
				<div className='user_name'>{name}</div>
				<div className='points_balance'>
					<div className='points_balance_image'>
						<img src={points_balance} />
					</div>
					<div className='points_balance_content'>
						{/* Points: <span>{state}</span> */}
						Balance:{' '}
						<span>
							{(parseFloat(parseInt(state)) / 4).toFixed(2)}
						</span>
					</div>
				</div>
				<div className='my_orders'>
					<Link to='/reseller-orders'>
						<i className=''>
							<img src={my_orders} />
						</i>
						<p>My Orders</p>
					</Link>
				</div>
				<div className='cart_value'>
					<button
						type='button'
						onClick={handleCart}
						disabled={
							isMultiple === 'true'
								? localStorage.getItem('cartItem') <= 0
								: props.pageType === 'edit'
								? props.cartQuan <= 0
								: localStorage.getItem('cartItem') <= 0
						}>
						<span>
							{isMultiple === 'true'
								? localStorage.getItem('cartItem')
									? localStorage.getItem('cartItem')
									: 0
								: props.pageType === 'edit'
								? props.cartQuan >= 1
									? 1
									: 0
								: localStorage.getItem('cartItem')
								? localStorage.getItem('cartItem')
								: 0}
						</span>
						<img src={shopping_cart} />
					</button>
				</div>
			</div>
		</div>
	);
};

export default Header;
